import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { CLEAR_TOAST_MESSAGE } from '../Redux/Enums/Contracts.Globals.Enums';
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
	icon: {

	},
	action: {

	}
}, { name: "toast" });

const ToastAlert = () => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const toast = useSelector(state => state.contract_globals.toast);

	const handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		dispatch({ type: CLEAR_TOAST_MESSAGE, payload: {} });
	};

	return toast ? (
		<Snackbar open={toast !== null} autoHideDuration={6000} onClose={handleClose} role='status'>
			<MuiAlert onClose={handleClose} severity={toast?.severity} elevation={6} variant="filled" classes={classes}>
				{toast?.message}
			</MuiAlert>
		</Snackbar>
	) : null;
};

export default ToastAlert;
